import React from 'react';
import PropTypes from 'prop-types';
import TermosConsentimentoCotacao from '../TermosConsentimentoCotacao';
import TabelaPlanos from '../../molecules/TabelaPlanos';
// import Simuladores from '../../../pages/simuladores';

const FormCotacao = React.lazy(() => import('../FormCotacao'));

function DrawerSolicitacaoCotacao({
  seguroSelecionado,
  pageLoading,
  dadosPessoais,
  enviarAceite,
  onSolicitarCotacao,
  onAlterarDadosPessoais,
  // onAlterarSeguroSelecionado,
}) {
  return (
    <>
      {dadosPessoais.exibeCotacao ? (
        <React.Suspense fallback={<div />}>
          <FormCotacao
            dadosPessoais={{ ...dadosPessoais }}
            onAlterarDadosPessoais={(dados) => onAlterarDadosPessoais(dados)}
            enviarAceite={enviarAceite}
          />
        </React.Suspense>
      ) : (
        <>
          {/*
            @TODO: HABILITAR_SIMULADOR_SAUDE tag para marcar os locais relacionados

            Foi removido o acesso aos simuladores de saúde.
            Possivelmente vão retornar em algum momento, por
            isso ainda decidimentos manter o código e não removê-lo
          */}
          {/* {['bradesco', 'unimed'].includes(seguroSelecionado.id) ? (
            <Simuladores target={seguroSelecionado.id} hideBreadcrumbs />
          ) : ( */}
          {dadosPessoais.exibeTabelaPlanos ? (
            <TabelaPlanos seguroSelecionado={seguroSelecionado} />
          ) : (
            <TermosConsentimentoCotacao
              seguroSelecionado={seguroSelecionado}
              pageLoading={pageLoading}
              dadosPessoais={dadosPessoais}
              enviarAceite={enviarAceite}
              onSolicitarCotacao={onSolicitarCotacao}
              onAlterarDadosPessoais={(dados) => onAlterarDadosPessoais(dados)}
              // onAlterarSeguroSelecionado={onAlterarSeguroSelecionado}
            />
          )}
          {/* )} */}
        </>
      )}
    </>
  );
}

DrawerSolicitacaoCotacao.propTypes = {
  seguroSelecionado: PropTypes.shape({
    id: PropTypes.string,
    nome: PropTypes.string,
    descricao: PropTypes.string,
    seguradoras: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  pageLoading: PropTypes.bool.isRequired,
  dadosPessoais: PropTypes.shape({
    lgpdChecked: PropTypes.bool,
    nomeUsuario: PropTypes.string,
    cpf: PropTypes.string,
    email: PropTypes.string,
    nomeCompleto: PropTypes.string,
    exibeTabelaPlanos: PropTypes.bool,
    exibeCotacao: PropTypes.bool,
  }).isRequired,
  enviarAceite: PropTypes.func.isRequired,
  onSolicitarCotacao: PropTypes.func.isRequired,
  onAlterarDadosPessoais: PropTypes.func.isRequired,
  // onAlterarSeguroSelecionado: PropTypes.func.isRequired, --- IGNORE ---
};

export default DrawerSolicitacaoCotacao;
